import { render, staticRenderFns } from "./TypicalCase.vue?vue&type=template&id=0fe0fe9d&"
import script from "./TypicalCase.vue?vue&type=script&lang=js&"
export * from "./TypicalCase.vue?vue&type=script&lang=js&"
import style0 from "./TypicalCase.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports